import React, { useState } from "react";
import styled from "styled-components";
import WhatsappImg from "../../assets/img/add/whatsapp.png"; // Make sure the path is correct

export default function ChatButton() {
  const phoneNumbers = [
    { number: "+923320006261", label: "Support" }
  ];
  const message = "Hi! I'm interested in your services. Can we discuss the details?";

  const [position, setPosition] = useState({
    x: window.innerWidth - 120,
    y: window.innerHeight - 120,
  });
  
  const [isDragging, setIsDragging] = useState(false);
  const [offset, setOffset] = useState({ x: 0, y: 0 });
  const [showDropdown, setShowDropdown] = useState(false);

  const handleMouseDown = (e) => {
    setIsDragging(true);
    setOffset({ x: e.clientX - position.x, y: e.clientY - position.y });
  };

  const handleMouseMove = (e) => {
    if (isDragging) {
      setPosition({ x: e.clientX - offset.x, y: e.clientY - offset.y });
    }
  };

  const handleMouseUp = () => setIsDragging(false);

  const handleButtonClick = () => setShowDropdown(!showDropdown);

  const handleDropdownItemClick = (number) => {
    const url = `https://wa.me/${number}?text=${encodeURIComponent(message)}`;
    window.open(url, "_blank");
    setShowDropdown(false);
  };

  return (
    <>
      <DraggableButton
        onMouseDown={handleMouseDown}
        onMouseMove={handleMouseMove}
        onMouseUp={handleMouseUp}
        onMouseLeave={handleMouseUp}
        onClick={handleButtonClick}
        style={{ left: position.x, top: position.y }}
      >
        <img src={WhatsappImg} alt="Whatsapp Chat" />
      </DraggableButton>

      {showDropdown && (
        <Dropdown style={{ left: position.x, top: position.y - 100 }}>
          {phoneNumbers.map((phone) => (
            <DropdownItem
              key={phone.number}
              onClick={() => handleDropdownItemClick(phone.number)}
            >
              {phone.label}
            </DropdownItem>
          ))}
        </Dropdown>
      )}
    </>
  );
}

const DraggableButton = styled.div`
  position: fixed;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: #25d366;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  cursor: grab;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;

  &:hover {
    background-color: #128c7e;
  }

  img {
    width: 60%;
    height: auto;
  }

  @media (max-width: 480px) {
    width: 50px;
    height: 50px;
  }
`;

const Dropdown = styled.div`
  position: fixed;
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  min-width: 100px;
  padding: 8px 0;
  transition: all 0.3s ease;
  border: 1px solid #eaeaea;

  &::before {
    content: "";
    position: absolute;
    top: -8px;
    right: 20px;
    border-width: 0 8px 8px 8px;
    border-style: solid;
    border-color: transparent transparent #ffffff transparent;
    z-index: 1001;
  }

  > div {
    padding: 10px 16px;
    font-size: 14px;
    color: #1e293b;
    cursor: pointer;
    transition: background 0.2s;

    &:hover {
      background-color: #f3f4f6;
    }

    &:not(:last-child) {
      border-bottom: 1px solid #f1f5f9;
    }
  }
`;


const DropdownItem = styled.div`
  padding: 10px 12px;
  cursor: pointer;
  font-size: 14px;

  &:hover {
    background-color: #f0f0f0;
  }
`;
